import { DOCUMENTATION_CATEGORY_INFO } from "@/lib/categoryInfo";

export function MyIncidentsTab({ incidents }) {
  return (
    <div className="space-y-4">
      {incidents.length === 0 && <p className="text-zinc-500 text-center py-10">You haven't filed any incident reports yet.</p>}
      {incidents.map((i) => (
        <div key={i.id} className="bg-white border border-zinc-200 rounded-sm p-5">
          <span className="inline-block mb-2 px-2 py-0.5 rounded-full text-xs font-bold uppercase border text-zinc-500 border-zinc-300">
            {DOCUMENTATION_CATEGORY_INFO[i.category]?.label}
          </span>
          <h3 className="font-display font-semibold text-zinc-950 mb-1">{i.title}</h3>
          <p className="text-zinc-500 text-xs">Status: {i.status}</p>
        </div>
      ))}
    </div>
  );
}
